<template>
  <span
    :class="
      twMerge(
        'font-serif text-lg uppercase leading-snug',
        typeof $attrs.class === 'string' ? $attrs.class : undefined,
      )
    "
  >
    <slot />
  </span>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
</script>
